import React, { useMemo } from 'react';
import { Field, Form, Icon, Tooltip } from '~/components';
import { colors } from '~/styles';
import SettingsFormSection from '../../SettingsFormSection';

export default function QuickBooks({ formik }) {
  const { client, accountingConnectionId } = formik.values;

  const qboCustomerId = useMemo(() => {
    if (!accountingConnectionId || !client?.qboClients) return null;
    return client.qboClients.find((m) => m.qboConnectionId === accountingConnectionId)?.qboCustomerId ?? null;
  }, [accountingConnectionId, client?.qboClients]);

  return (
    <SettingsFormSection title="QuickBooks" help="Select a QuickBooks project.">
      <Form.Control>
        <Field.QBOProjectSelect
          name="qboProjectId"
          placeholder="QuickBooks Project"
          placement="top"
          include={formik.values.qboProjectId}
          disabled={!qboCustomerId}
          qboConnectionId={accountingConnectionId}
          qboCustomerId={qboCustomerId}
          showEmptyOption
        />

        {!qboCustomerId && (
          <div style={{ flex: 0, display: 'flex', alignItems: 'center' }}>
            <Tooltip message="This project's client is not mapped to a QuickBooks customer.">
              <Icon icon="exclamation-triangle" color={colors.warning} />
            </Tooltip>
          </div>
        )}
      </Form.Control>
    </SettingsFormSection>
  );
}
